import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const createLibrary = (iconsObj: {
  [key: string]: IconDefinition;
}): IconDefinition[] => Object.entries(iconsObj).map(([_, value]) => value);
